import { render, staticRenderFns } from "./PesvFase2.vue?vue&type=template&id=179c2fce"
import script from "./PesvFase2.vue?vue&type=script&lang=js"
export * from "./PesvFase2.vue?vue&type=script&lang=js"
import style0 from "./PesvFase2.vue?vue&type=style&index=0&id=179c2fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports